import {
  listGroupsinaproject,
  ListGroupsinaprojectResponse,
  ListGroupsinaprojectData,
} from '@data-access/connect/tc-tcps';
import type { Client } from '@data-access/connect/tc-issue-management';
import { useQuery, UseQueryResult, QueryClient } from '@tanstack/solid-query';
import { Accessor } from 'solid-js';

export class TcpsGroupApiService {
  constructor(
    private readonly client: Client,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS6138: Reserved for future use
    private readonly queryClient: QueryClient
  ) {}

  // Query for listing all groups in a project
  public getProjectGroupsQuery(
    options: Accessor<Omit<ListGroupsinaprojectData, 'client'>>
  ): UseQueryResult<ListGroupsinaprojectResponse, Error> {
    return useQuery(() => ({
      queryKey: ['project-groups', options()],
      queryFn: async (): Promise<ListGroupsinaprojectResponse> => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        const response = await listGroupsinaproject({
          client: this.client as any,
          ...options(),
        });

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (response.error) {
          throw new Error('Failed to list project groups');
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        return response.data!;
      },
      enabled: !!options().query.projectId,
    }));
  }
}
